let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iyv15")).then(() => parcelRequire('8OgoK'));